import { combineReducers } from '@reduxjs/toolkit'
import pricingReducer from './pricingSettingsReducer'
import landingPageReducer from './landingPageSettingsReducer'
import accessCodeReducer from './registrationAccessCodeReducer'

const communitySettingsReducer = combineReducers({
  pricing: pricingReducer,
  landingPage: landingPageReducer,
  accessCodePage: accessCodeReducer,
})

export default communitySettingsReducer
